
export function cleanDocument(document: string): string {
  return document.replace(/\D/g, '');
}

export function isValidCPF(cpf: string): boolean {
  const cleanCpf = cleanDocument(cpf);

  if (cleanCpf.length !== 11) {
    return false;
  }

  if (/^(\d)\1+$/.test(cleanCpf)) {
    return false;
  }

  let sum = 0;
  for (let i = 0; i < 9; i++) {
    sum += parseInt(cleanCpf.charAt(i)) * (10 - i);
  }
  let remainder = 11 - (sum % 11);
  let digit1 = remainder >= 10 ? 0 : remainder;

  if (digit1 !== parseInt(cleanCpf.charAt(9))) {
    return false;
  }

  sum = 0;
  for (let i = 0; i < 10; i++) {
    sum += parseInt(cleanCpf.charAt(i)) * (11 - i);
  }
  remainder = 11 - (sum % 11);
  let digit2 = remainder >= 10 ? 0 : remainder;

  if (digit2 !== parseInt(cleanCpf.charAt(10))) {
    return false;
  }

  return true;
}

export function isValidCNPJ(cnpj: string): boolean {
  const cleanCnpj = cleanDocument(cnpj);

  if (cleanCnpj.length !== 14) {
    return false;
  }

  if (/^(\d)\1+$/.test(cleanCnpj)) {
    return false;
  }

  let length = cleanCnpj.length - 2;
  let numbers = cleanCnpj.substring(0, length);
  let digits = cleanCnpj.substring(length);
  let sum = 0;
  let pos = length - 7;

  for (let i = length; i >= 1; i--) {
    sum += parseInt(numbers.charAt(length - i)) * pos--;
    if (pos < 2) {
      pos = 9;
    }
  }

  let result = sum % 11 < 2 ? 0 : 11 - (sum % 11);

  if (result !== parseInt(digits.charAt(0))) {
    return false;
  }

  length = length + 1;
  numbers = cleanCnpj.substring(0, length);
  sum = 0;
  pos = length - 7;

  for (let i = length; i >= 1; i--) {
    sum += parseInt(numbers.charAt(length - i)) * pos--;
    if (pos < 2) {
      pos = 9;
    }
  }

  result = sum % 11 < 2 ? 0 : 11 - (sum % 11);

  if (result !== parseInt(digits.charAt(1))) {
    return false;
  }

  return true;
}

export function isValidCPFOrCNPJ(document: string): boolean {
  const cleanDoc = cleanDocument(document);

  if (cleanDoc.length === 11) {
    return isValidCPF(cleanDoc);
  } else if (cleanDoc.length === 14) {
    return isValidCNPJ(cleanDoc);
  }

  return false;
}

export function formatCPF(cpf: string): string {
  const cleanCpf = cleanDocument(cpf);
  if (cleanCpf.length !== 11) {
    return cpf;
  }
  return cleanCpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
}

export function formatCNPJ(cnpj: string): string {
  const cleanCnpj = cleanDocument(cnpj);
  if (cleanCnpj.length !== 14) {
    return cnpj;
  }
  return cleanCnpj.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
}

export function formatCPFOrCNPJ(document: string): string {
  const cleanDoc = cleanDocument(document);

  if (cleanDoc.length <= 11) {
    if (cleanDoc.length <= 3) {
      return cleanDoc;
    } else if (cleanDoc.length <= 6) {
      return cleanDoc.replace(/(\d{3})(\d{0,3})/, '$1.$2');
    } else if (cleanDoc.length <= 9) {
      return cleanDoc.replace(/(\d{3})(\d{3})(\d{0,3})/, '$1.$2.$3');
    } else {
      return cleanDoc.replace(/(\d{3})(\d{3})(\d{3})(\d{0,2})/, '$1.$2.$3-$4');
    }
  }

  if (cleanDoc.length <= 2) {
    return cleanDoc;
  } else if (cleanDoc.length <= 5) {
    return cleanDoc.replace(/(\d{2})(\d{0,3})/, '$1.$2');
  } else if (cleanDoc.length <= 8) {
    return cleanDoc.replace(/(\d{2})(\d{3})(\d{0,3})/, '$1.$2.$3');
  } else if (cleanDoc.length <= 12) {
    return cleanDoc.replace(/(\d{2})(\d{3})(\d{3})(\d{0,4})/, '$1.$2.$3/$4');
  } else {
    return cleanDoc.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{0,2})/, '$1.$2.$3/$4-$5');
  }
}
